const base = process.env.REACT_APP_BASEURL;
const api = process.env.REACT_APP_API_URL;
const dashboardUrl = "/cms";
const authUrl = "/auth";

module.exports = {
  base: base,
  dashboard: dashboardUrl,
  auth: authUrl,
  api: api,
  login: authUrl + "/login",
  forgotPassword: authUrl + "/forgot-password",
  acceptInvite: authUrl + "/invite/",
  products: dashboardUrl + "/products",
  productList: dashboardUrl + "/products/product-list",
  addProduct: dashboardUrl + "/products/add-product",
  editProduct: dashboardUrl + "/products/edit-product/",
  stock: dashboardUrl + "/products/stock",
  reconciliationLog: dashboardUrl + "/products/reconciliation",
  reconciliationDetail: dashboardUrl + "/products/reconciliation/detail/",
  forecast: dashboardUrl + "/products/forecast",
  promotions: dashboardUrl + "/products/promotions",
  priceLists: dashboardUrl + "/products/price-lists",
  ordersList: dashboardUrl + "/orders",
  adminList: dashboardUrl + "/customers/admins",
  userList: dashboardUrl + "/customers/users",
  groups: dashboardUrl + "/groups",
  discountCodes: dashboardUrl + "/discounts",
  customerList: dashboardUrl + "/companies/all",
  snelstartCustomerList: dashboardUrl + "/companies/snelstart",
  exactCustomerList: dashboardUrl + "/companies/exact",
  snelstartOrdersList: dashboardUrl + "/orders/snelstart",
  customerListPending: dashboardUrl + "/companies/pending",
  users: dashboardUrl + "/admin/users",
  notifications: dashboardUrl + "/notifications",
  reports: dashboardUrl + "/reports",
  customersReport: dashboardUrl + "/reports/customers",
  productsReport: dashboardUrl + "/reports/products",
  deliveriesReport: dashboardUrl + "/reports/deliveries",
  complaintsReport: dashboardUrl + "/reports/complaints",
  stockReport: dashboardUrl + "/reports/stock",
  deliveriesReportSooCool: dashboardUrl + "/reports/deliveries/soocool",
  productsAvailabilityReport: dashboardUrl + "/reports/products/availability",
  chefsFarmList: dashboardUrl + "/orders/chefs-farm",
  growyList: dashboardUrl + "/orders/growy",
  chefsFarmInvoiceList: dashboardUrl + "/finance/invoices/chefs-farm",
  growyInvoiceList: dashboardUrl + "/finance/invoices/growy",
  chefsFarmComplaintList: dashboardUrl + "/finance/complaints/chefs-farm",
  growyComplaintList: dashboardUrl + "/finance/complaints/growy",
  createSnelstartRelatie: api + "/api/snelstart/relatie",
  createExactAccount: api + "/api/exact/account",
  updateExactAccount: api + "/api/exact/account",
  exactInvoice: api + "/api/exact/invoice",
  getAllSnelstartRelaties: api + "/api/snelstart/relaties",
  getAllExactAccounts: api + "/api/exact/accounts",
  getSnelstartOrders48h: api + "/api/snelstart/orders/48h",
  getSnelstartOrdersDateRange: api + "/api/snelstart/orders/date-range",
  getAllSnelstartProducts: api + "/api/snelstart/products",
  getAllExactProducts: api + "/api/exact/products",
  sendCustomerRequestRejectedMail: api + "/api/mail/customer_request/rejected",
  sendCustomerRequestAcceptedMail: api + "/api/mail/customer_request/accepted",
  snelstartOrder: api + "/api/snelstart/verkooporder",
  getExactInvoice: api + "/api/exact/invoice",
  exactInvoiceAddLine: api + "/api/exact/invoice/addnewline",
  getExactInvoiceHistory: api + "/api/exact/invoice/history",
  sendInvite: api + "/api/mail/invite/cms",
  inviteNewAppUser: api + "/api/mail/invite/app",
  deleteUser: api + "/api/firestore/user",
  changeUserPassword: api + "/api/firestore/password",
  getSooCoolLabels: api + "/api/soocool/shipping-labels",
  sooCoolOrder: api + "/api/soocool/order",
  freshingBoxOrder: api + "/api/freshingbox/order/announce",
  freshingBoxLabels: api + "/api/pdf/freshingbox-labels",
  stockApiUrl: api + "/api/stock",
  dailyCloudFunctionRefresh: api + "/api/stock/refresh",
  updateBatchProjections: api + "/api/stock/projections/batch",
  sendEmailOrderUpdate: api + "/api/mail/order-update",
  updateDateCountedStock: api + "/api/stock/counted-stock",
  updateProjectionsFromDate: api + "/api/stock/projections/from-date",
  updateBatchCountedStock: api + "/api/stock/batch-counted-stock",
  packingSlipApi: api + "/api/pdf/packing-slip",
  combinedPackingSlipApi: api + "/api/pdf/packing-slip/combined",
  multiplePackingSlipsCombinedApi: api + "/api/pdf/multiple-packing-slips/combined",
  processOrder: api + "/api/orders/process",
  picklistApi: api + "/api/pdf/picklist",
  multiplePicklistsApi: api + "/api/pdf/multiple-picklists",
  generateAndEmailDocuments: api + "/api/pdf/generate-and-email-documents",
  shippingLabelsCombinedApi: api + "/api/pdf/shipping-labels/combined",
  stockSyncExact: api + "/api/exact/stock/sync",
  readOrdersExcel: api + "/api/excel/orders",
  readLeadsExcel: api + "/api/excel/leads",
  readOrdersEdifact: api + "/api/edifact/orders",
  generateEdifactAperak: api + "/api/edifact/aperak",
  describeEdifactMessage: api + "/api/edifact/describe",
  previewEdifactDesadv: api + "/api/edifact/desadv/preview",
  generateEdifactDesadv: api + "/api/edifact/desadv",
  sendEdifactDesadv: api + "/api/edifact/desadv/send",
  sendEdifactInvoic: api + "/api/edifact/invoic/send",
  carryOverStock: api + "/api/stock/carry-over",
  countryList: dashboardUrl + "/countries/list",
  addCountry: dashboardUrl + "/countries/add/",
  viewCountry: dashboardUrl + "/countries/view/",
  editCountry: dashboardUrl + "/countries/edit/",
  profile: dashboardUrl + "/profile",
  chat: dashboardUrl + "/chat",
  whatsappTemplates: dashboardUrl + "/chat/settings/whatsapp-templates",
  resetUserMfa: api + "/api/firestore/mfa/reset",
  checkMfaStatus: api + "/api/firestore/mfa/check",
  acquisitionLeads: dashboardUrl + "/acquisition/leads",
  acquisitionShipments: dashboardUrl + "/acquisition/shipments",
  chatContextManagement: dashboardUrl + "/chat/context-management",
  ediLog: dashboardUrl + "/edilog",
};
